import React, { lazy, Suspense } from "react";
import AppHeader from "../components/header/index";
import { withStyles, Grid } from "@material-ui/core";
import GoldenLayoutComponent from "../layout/goldenLayoutComponent";
import {
  getLayoutConfiguration,
  registerComponents,
} from "../layout/layoutConfiguration";
import { AppLoading } from "../loaders/loaders";
import { isEmpty } from "lodash";
import { getDataWithQueryString, postData } from "../api/componentAPIs";
import AuthService from "../auth/AuthService";
import { withUserProfile } from "../userProfile/userProfileContext";
import { compose } from "recompose";
import "../styles/customScrollbar.scss";

import SignalRClient from "../signalR/index";
import Events from "../utilities/EventEmitter";
import NotificationBanner from "../components/common/NotificationBanner";
import { withSnackbar } from "notistack";
import notificationConstant from "../components/modules/Settings/User/Notifications/constants";
import { withFeatureFlags } from "../userProfile/featureFlagsContext";
import { Refresh } from "@material-ui/icons";
import { RMAXLogger } from "../services/LoggerService/RMAXLogger";
import appConstants, { USER_ROLE } from "../appConstants";
import { hasSingleReadOnlyRole } from "../auth/utils";
import { withAppConfig } from "../appConfigContext";
import withRouter from "./withRouter";

const RMAXMaintenance = lazy(() =>
  import("../components/common/RMAXMaintenance")
);

const styles = (theme) => ({
  layout: {
    backgroundColor: theme.AppBGColor,
    flexGrow: 1,
  },
  appContainer: {
    height: "100%",
    flexDirection: "column",
    flexWrap: "initial",
  },
  notification: {
    flexBasis: "unset",
    minHeight: 45,
  },
  appHeader: {
    height: "fit-content",
    flexBasis: "unset",
    minHeight: 45,
  },

  layoutContainer: {
    height: "100%",
    flexGrow: 1,
  },
  layoutContainerWithNotification: {
    height: "calc(100% - 73px)",
    flexGrow: 1,
  },
});

class RouteRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserInfoLoaded: false,
      glEventHub: null,
      showNotificationBanner: false,
      notificationData: null,
      featureFlags: [],
      showMaintenanceDialog: false,
    };
  }
  updateglEventHub = (eventHubInstance) => {
    if (this.state.glEventHub !== eventHubInstance) {
      this.setState({ glEventHub: eventHubInstance });
    }
  };
  componentDidMount() {
    if (!this.props.userData?.userProfile) {
      this.refreshUserInfo(undefined, undefined, false); //pass undefined here so that terminal is selected from session on hard refresh.
    } else {
      if (isEmpty(this.state.featureFlags)) {
        this.getEnabledFeatures(this.props.userData.userProfile.terminal.id, this.props.userData.userProfile.terminal.code);
      }
      this.setState({
        isUserInfoLoaded: true,
      });
    }
    this._isComponentMounted = true;
    Events.on("RefreshUserInfo", this.refreshUserInfo);
    Events.on("UpdateNotifications", this.getActiveNotifications);
    Events.on('signalRConnectionFailure', this.handleSignalRConnectionFailure);
    Events.on('onMemoryUsageExceeded', this.handleMemoryUsageExceeded);
  }

  componentWillUnmount() {
    Events.removeListener("RefreshUserInfo", this.refreshUserInfo);
    Events.removeListener("UpdateNotifications", this.getActiveNotifications);
    Events.removeListener('signalRConnectionFailure', this.handleSignalRConnectionFailure);
    Events.removeListener('onMemoryUsageExceeded', this.handleMemoryUsageExceeded);
    this._isComponentMounted = false;
  }

  componentDidUpdate(prevProps) {
    this.handleThemeChange(prevProps.userData.userProfile?.theme);
  }

  // Handle theme changes for scrollbar styles
  handleThemeChange = (prevTheme) => {
    const currentTheme = this.props.userData.userProfile?.theme;
    if (currentTheme !== prevTheme) {
      document.body.classList.remove(currentTheme, prevTheme);
      if (currentTheme) {
        document.body.classList.add(currentTheme);
      }
    }
  };

  handleSignalRConnectionFailure = () => {
    RMAXLogger.error(`SignalR connection closed`);
    this.setState({
      showNotificationBanner: true,
      notificationData: {
        type: notificationConstant.TYPE_ERROR,
        message: 'Connection Interrupted: Please reconnect to re-establish a real-time server link.',
        linkUrl: null,
        isClosable: false,
        buttonLabel : <><Refresh color='primary'/> Reconnect</>
      },
      showMaintenanceDialog: false
    });
  }

  handleMemoryUsageExceeded = () => {
    this.setState({
      showNotificationBanner: true,
      notificationData: {
        type: notificationConstant.TYPE_WARNING,
        message: 'The browser is using a high amount of memory. Refreshing page may improve performance.',
        linkUrl: null,
        isClosable: true,
        buttonLabel: (
          <>
            <Refresh color="primary" />
            Refresh
          </>
        )
      },
      showMaintenanceDialog: false
    });
  }

  refreshUserInfo = (
    terminalId,
    notificationMessage = null,
    refreshData = true
  ) => {
    this.getUserInfo(notificationMessage, refreshData, terminalId);
  };
  onNotificationBannerClose = () => {
    const reqObject = {
      notificationId: this.state.notificationData.notificationId,
    };
    postData("DisableNotification", reqObject).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        console.log(
          `Notification ${reqObject.notificationId} disabled for user ${this.props.userData.userProfile.userName}`
        );
      }
      this.getActiveNotifications();
    });
    this.setState({ showNotificationBanner: false });
  };

  hasDispatchAccess = (roles, isReadOnlyRole) => {
    return this.props.configJSON.enableDispatch && (isReadOnlyRole || roles.some((role) => [USER_ROLE.DISPATCHER, USER_ROLE.MANAGER].includes(role)));
  }

  getUserInfo=(notificationMessage,refreshData,terminalId=sessionStorage.getItem("selectedTerminal"))=>{
    getDataWithQueryString("GetUserInfo", `terminalId=${terminalId}`).then(response=>{
        if(response.status === 200 && response.data){
            const userDetails = response.data;
            const isReadOnlyRole = hasSingleReadOnlyRole(userDetails.roles);
            
          this.getActiveNotifications();
          this.props.userData.updateUserProfile({
            userId: userDetails.userId,
            userName: AuthService.getUsername(),
            terminal: {
              id: userDetails.terminalId,
              location: {
                lat: userDetails.terminalLatitude,
                lng: userDetails.terminalLongitude,
              },
              name: userDetails.terminalName,
              code: userDetails.terminalCode,
              offset: userDetails.terminalOffset,
              address: userDetails.terminalAddress,
              country: userDetails.terminalCountry,
            },
            planDate: userDetails.planDate,
            lastPublishedDateTime: userDetails.lastPublishedDateTime,
            defaultDockStartTimeInMins: userDetails.defaultDockStartTimeInMins,
            ibEtaCutOff : userDetails.ibEtaCutOff,
            defaultIbEtaCutOffInMins : userDetails.defaultIbEtaCutOffInMins,
            scenarioID: userDetails.scenarioId,
            scenarioName: userDetails.scenarioName,
            columnPref: JSON.parse(userDetails.userColumnPreference),
            theme: userDetails.theme,
            terminals: userDetails.terminals,
            isDefaultScenario: userDetails.isDefaultScenario,
            jobTitle: userDetails.jobTitle,
            roles: userDetails.roles,
            isAdmin: userDetails.roles.some((x) => x == USER_ROLE.ADMIN),
            isReadOnlyRole,
            enableDispatch: this.hasDispatchAccess(userDetails.roles, isReadOnlyRole),
            geoJson: userDetails.geoJson || null
          });
          this.getEnabledFeatures(userDetails.terminalId, userDetails.terminalCode).then(() => {
            // Load UI after feature flags are loaded
            if (this._isComponentMounted) {
              this.setState({
                isUserInfoLoaded: true,
              });
            }
          });
          this.props.userData.toggleTheme(userDetails.theme);

          if (document) {
            document.title = `${userDetails.terminalCode} - RouteMAX`;
          }

          SignalRClient.disconnectFromHub(userDetails.scenarioId).then(() => {
            SignalRClient.connectToHub(
              userDetails.scenarioId,
              userDetails.terminalCode
            );
          });

          refreshData && Events.emit("RefreshIBStore",{
            refreshAdditionalData: {
              fetchAnchorPoint: true,
              fetchTrailerData: true,
              fetchWavesData: true
            }
          });

          if (notificationMessage) {
            this.props.enqueueSnackbar(notificationMessage, {
              variant: "success",
            });
          }
        }
      }
    );
  };

  getActiveNotifications = () => {
    getDataWithQueryString("GetActiveNotificationForUser").then((response) => {
      if ([200, 204].includes(response?.status)) {
        const isMaintenanceNotification =
          response.data.type === notificationConstant.TYPE_MAINTENANCE;
        if (response.data) {
          this.setState({
            showNotificationBanner: !isMaintenanceNotification,
            notificationData: response.data,
            showMaintenanceDialog: isMaintenanceNotification,
          });
        } else {
          this.setState({
            showNotificationBanner: false,
            notificationData: null,
            showMaintenanceDialog: false,
          });
        }
      }
    });
  };

  getEnabledFeatures = (terminalId, terminalCode) => {
    if (!terminalId || !terminalCode) {
      Events.emit('NavigateToAccessDenied', {
        url: appConstants.NAV_URLS.ACCESS_DENIED,
        customMessage: "You don't have access to any terminal!",
        hideHomeButton: true
      });
      return Promise.resolve();
    }
    const featuresPromiseArray = [];
    
    const settingsFeaturePromise = getDataWithQueryString(
      "GetIBPlanningEnableFeaturesByTerminal",
      `terminalId=${terminalId}`
    );
    featuresPromiseArray.push(settingsFeaturePromise);
    const cityDispatchFeaturePromise = getDataWithQueryString(
      "GetDispatchEnableFeaturesByTerminal",
      `terminalCode=${terminalCode}`
    );
    
    this.props.configJSON.enableDispatch && featuresPromiseArray.push(cityDispatchFeaturePromise);

    return Promise.all(featuresPromiseArray)
      .then(([settingsResponse, cityDispatchResponse]) => {
        const settingsFeatures = settingsResponse?.status === 200 ? settingsResponse.data : [];
        const cityDispatchFeatures = cityDispatchResponse?.status === 200 ? cityDispatchResponse.data : [];
        
        const combinedFeatures = [...settingsFeatures, ...cityDispatchFeatures];
        
        this.setState({
          featureFlags: combinedFeatures,
        });
        this.props.featureFlags.setFeatureFlags(combinedFeatures);
      });
  };

  closeMaintenanceModal = () => {
    if (this.props.userData.userProfile.isAdmin) {
      this.setState({
        showMaintenanceDialog: false,
        notificationData: null,
      });
    }
  };

  render() {
    const { classes, configJSON, router } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    const { notificationData } = this.state;
    const url = router.location.pathname;
    return (
      <div
        id="appContainer"
        className={`${classes.layout} ${theme}`}
      >
        {!this.state.isUserInfoLoaded ? (
          <AppLoading />
        ) : (
          <React.Fragment>
            <Grid container className={classes.appContainer}>
              {this.state.showNotificationBanner && (
                <Grid item xs={12} classes={{ item: classes.notification }}>
                  <NotificationBanner
                    data={this.state.notificationData}
                    onClose={this.onNotificationBannerClose}
                  />
                </Grid>
              )}
              <Grid item xs={12} classes={{ item: classes.appHeader }}>
                <AppHeader
                  glEventHub={this.state.glEventHub}
                  featureFlags={this.state.featureFlags}
                  userData={this.props.userData}
                  isNotificationVisible={this.state.showNotificationBanner}
                  configJSON={configJSON}
                />
              </Grid>
              <Grid item xs={12} classes={{ item: this.state.showNotificationBanner? classes.layoutContainerWithNotification: classes.layoutContainer }}>
                <GoldenLayoutComponent //config from simple react example: https://golden-layout.com/examples/#qZXEyv
                  htmlAttrs={this.state.showNotificationBanner ? {style: { height: "calc(100% - 73px)", width: "100%" }}:{ style: { height: "100%", width: "100%" } }}
                  resize={this.state.showNotificationBanner}
                  path={url}
                  config={{
                    dimensions: {
                      borderWidth: 8,
                      headerHeight: 45.95,
                    },
                    settings: {
                      hasHeaders: true,
                      popoutWholeStack: true,
                      closePopoutsOnUnload: true,
                      showMaximiseIcon: true,
                      showCloseIcon: false,
                      reorderEnabled: false,
                      // Keep tab order stable when an overflowed tab (e.g. Trailer Moves) is selected
                      reorderOnTabMenuClick: false,
                      // Prefer tab overlap over hiding tabs in the overflow dropdown
                      tabOverlapAllowance: 100,
                      tabControlOffset: 0,
                    },

                    content: getLayoutConfiguration(url,configJSON),
                  }}
                  registerComponents={(myLayout) => {
                    registerComponents(url, myLayout,configJSON);
                  }}
                  updateEventHub={this.updateglEventHub}
                  featureFlags={this.state.featureFlags}
                />
              </Grid>
            </Grid>
            <Suspense fallback={<AppLoading />}>
              {this.state.showMaintenanceDialog && (
                <RMAXMaintenance
                  message={notificationData.message}
                  onClose={this.closeMaintenanceModal}
                  isClosable={this.props.userData.userProfile.isAdmin}
                />
              )}
            </Suspense>
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default compose(
  withUserProfile,
  withFeatureFlags,
  withSnackbar,
  withAppConfig,
  withStyles(styles),
  withRouter,
)(RouteRenderer);
